import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

class UserDataProfile extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      userInfo:{},
      schoolInfo:{},
      kla:[],
      subject:[],
    };
    autoBind(this);


    // get kla and subject data from database
    //var requestObj;
    //requestObj = {table: "kla",filter: {}};


    // this.props.root.refs.API.request("get_list", requestObj, this.getKLAOK, this.getKLAFail);
    // requestObj = {table: "subject",filter: {}};
    // this.props.root.refs.API.request("get_list", requestObj, this.getSubjectOK, this.getSubjectFail);

  }

  getKLAAndSubjectFromServer(){
    var requestObj;
    requestObj = {
      table: "kla",
      filter: {},
      order_by: "id",
      order_mode: "ASC",
    };
    this.props.root.refs.API.request("get_list", requestObj, this.getKLAOK, this.getKLAFail);
    requestObj = {
      table: "subject",
      filter: {},
      order_by: "id",
      order_mode: "ASC",
    };
    this.props.root.refs.API.request("get_list", requestObj, this.getSubjectOK, this.getSubjectFail);

  }

  updateUserInfo(res){
    console.log("updateUserInfo ");
    this.setState({userInfo: res.body.user_info});
    this.state.userInfo = res.body.user_info;
  }

  updateSchoolInfo(res){
    // console.log("updateSchoolInfo");
    this.setState({schoolInfo: res.body.school_info});
    this.state.schoolInfo = res.body.school_info;
  }

  // API handlers
  getKLAOK(res){
    this.setState({kla:res.body.result})
    this.state.kla = res.body.result;
  }

  getKLAFail(err){
    console.log("get KLA from server failed");
  }

  getSubjectOK(res){
    this.setState({subject:res.body.result})
    this.state.subject = res.body.result;
  }

  getSubjectFail(err){
    console.log("get subject from server failed");
  }


  getKLAByID(id){
    for (var i = 0; i < this.state.kla.length; i++) {
      var objKLA = this.state.kla[i];
      if(objKLA.id == id){
        return objKLA;
      }
    }
    return null;
  }

  getSubjectByID(id){
    for (var i = 0; i < this.state.subject.length; i++) {
      var objSubject = this.state.subject[i];
      if(objSubject.id == id){
        return objSubject;
      }
    }
    return {};
  }

  render() {
      return (
        <div>

        </div>
      )
  }
}

export default UserDataProfile;
